var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "hoverfill",
    cx: 25,
    cy: 25,
    r: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "content",
    d: "M32.6988 13.4878H36.8042L27.8352 23.7388L38.3865 37.6881H30.1249L23.6541 29.2279L16.25 37.6881H12.1422L21.7354 26.7235L11.6135 13.4878H20.0849L25.9339 21.2207L32.6988 13.4878ZM31.258 35.2309H33.5328L18.8488 15.816H16.4076L31.258 35.2309Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.b32e46710964ddb062729ae91c893bfa.svg";
export { ForwardRef as ReactComponent };